module.exports = __webpack_public_path__ + "media/mypage/images/icons/credit-cards/laser-ec18f5089c5f8a9840c9ad37d5eae436.png";